import { useNavigate, useLocation, useParams } from "react-router-dom"
import { Box, Button } from "@mui/material"

function Sidebar() {
  const navigate = useNavigate()
  const location = useLocation()
  const { userId } = useParams()

  const menuItems = [
    { label: "Details", path: `/member/details/${userId}` },
    { label: "Specialists", path: `/member/details/${userId}/specialists` },
    {
      label: "Appointments",
      path: `/member/details/${userId}/appointments`,
    },
  ]

  return (
    <Box
      sx={{
        p: 2,
        top: 20,
        width: 250,
        bgcolor: "white",
        overflow: "auto",
        position: "sticky",
        borderRadius: "12px",
        border: "1px solid #00000012",
        display: { xs: "none", xl: "block" }
      }}
    >

      {menuItems.map((item, i) => (
        <Button
          key={i}
          onClick={() => navigate(item.path)}
          variant={
            location.pathname === item.path
              ? "activeSidebarMenu"
              : "sidebarMenu"
          }
          fullWidth
          sx={{ justifyContent: "flex-start", mb: 1 }}
        >{item.label}
        </Button>
      ))}

    </Box>
  )
}

export default Sidebar